module.exports = __webpack_public_path__ + "static/media/sz.fa1a994d.svg";